import React from 'react';
import { DisciplineRowStyled } from './styled';
import { Box, Text, Checkbox } from '@bechtel/gds';
import { WorkPackageDiscipline } from '@bechtel/types';
import { FieldArray, FormikProps } from 'formik';
import { FormikState, SortBy } from '../index';
import { filter, orderBy, toLower, includes, findIndex } from 'lodash';

interface DisciplineListProps {
  form: FormikProps<FormikState>;
  sort: SortBy;
  search: string;
}

export const DisciplineList: React.FC<DisciplineListProps> = ({ form, sort, search }) => {
  const { disciplines } = form.values;
  const searchedDisciplinesDetailArr = filter(disciplines, (d: WorkPackageDiscipline) => {
    const searchValue = toLower(search);
    const name = toLower(d.name || '');
    return includes(name, searchValue);
  });
  const sortedDisciplinesDetailArr = orderBy(searchedDisciplinesDetailArr, ['name'], [sort.id]);
  return (
    <FieldArray name="disciplines">
      {(arrayHelpers) => {
        return (
          <>
            {sortedDisciplinesDetailArr &&
              sortedDisciplinesDetailArr.map((item: WorkPackageDiscipline) => {
                return (
                  <DisciplineRowStyled key={item.id}>
                    <Box
                      px={{ sm: '500' }}
                      py={{ sm: '500' }}
                      flexGrow={{ sm: 1 }}
                      onClick={() => {
                        arrayHelpers.replace(
                          findIndex(disciplines, (inner: WorkPackageDiscipline) => inner.id === item.id),
                          {
                            ...item,
                            isActive: !item.isActive,
                          }
                        );
                      }}
                    >
                      <Box mr={{ sm: '600' }}>
                        <Checkbox type="checkbox" checked={item.isActive} readOnly />
                      </Box>
                      <Text color="grey.1000" size="400">
                        {item.name}
                      </Text>
                    </Box>
                  </DisciplineRowStyled>
                );
              })}
          </>
        );
      }}
    </FieldArray>
  );
};
